export const getIsLoadingSocialMedia = state => state.socialMedia.isLoading;
export const getSocialmedia = state => state.socialMedia.socialMedia;
export const getIsErrorSocialMedia = state => state.socialMedia.errorMessage;
